import actions from "actions";
import axios from "axios";
import constants from "constants";
import { toast } from "react-toastify";
import { push } from "redux-router";
import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import storage from "services/storage";
import validator from "services/validator.js";
import {
  setNotification,
  setNotificationsCount,
  setNotificationsInfinite,
} from "../actions/users";
import { GET_NOTIFICATIONS } from "../constants/actions";

const {
  cleanErrors,
  addRequestError,
  addValidateError,
  addErrorsSaga,
  updateUser,
  setProfileConfirmation,
  updateNovonordiskUser,
  // setSponsorsRepresentatives,
  // setSponsorsRepresentativesRequest,
} = actions;

const {
  CREATE_USER_SAGA,
  CREATE_USER_FAILED,
  API_CREATE_USER,
  API_SHOW_USER,
  ERROR_TYPE_USER_CREATE_ERROR,
  ERROR_TYPE_USER_UPDATE_ERROR,
  LOAD_CURRENT_USER_SAGA,
  API_UPDATE_USER,
  UPDATE_USER_SAGA,
  ZOOM_INFO_STATUS,
  UPDATE_URL_USER_SAGA,
  SEND_DISCIPLINES_APPROVE_SAGA,
  API_SEND_APPROVE_USERS,
  SEND_CONFIRMATION_USERS_SAGA,
  API_CONFIRMATION_USERS,
  APPROVE_USER_REQUEST_SAGA,
  REJECT_USER_REQUEST_SAGA,
  APPROVE_IPNA_REQUEST_SAGA,
  REJECT_IPNA_REQUEST_SAGA,
  UPDATE_NOVONORDISK_USER_SAGA,
  CHECKBOX_NOVONORDISK_USER_SAGA,
  // GET_SPONSORS_REPRESENTATIVE,
  API_CHECKBOX_NOVONORDISK_USER_SAGA,
  // API_SPONSORS_REPRESENTATIVES,
  // GET_SPONSORS_REPRESENTATIVE_REQUESTS,
  // API_SPONSORS_REPRESENTATIVES_REQUESTS,
  LOAD_NOTIFICATIONS,
  API_NOTIFICATIONS,
  LOAD_NOTIFICATIONS_COUNT,
  API_NOTIFICATIONS_COUNT,
  MARK_NOTIFICATIONS,
} = constants;

const apiGetNotifications = (params) => {
  return axios.get(API_NOTIFICATIONS, {
    params,
  });
};

const apiMarkNotifications = (notification_ids) => {
  return axios.post(`${API_NOTIFICATIONS}/update`, { notification_ids });
};

const apiGetNotificationsCount = (params) => {
  return axios.get(API_NOTIFICATIONS_COUNT, {
    params,
  });
};

const apiCreateUser = (user) => {
  return axios.post(API_CREATE_USER, {
    user: user,
  });
};

const apiUpdateUser = (user) => {
  return axios.put(`${API_UPDATE_USER}${user.id}`, {
    user: user,
  });
};

const apiSendApproveUsersSaga = (confirmation_users) => {
  axios.put(API_SEND_APPROVE_USERS, {
    confirmation_users,
  });
};

const apiSendConfirmationUsersSaga = (confirmation_users) => {
  axios.post(API_SEND_APPROVE_USERS, {
    confirmation_users,
  });
};

const apiApproveUserRequestSaga = ({ id }) => {
  axios.put(`${API_CONFIRMATION_USERS}/${id}`);
};

const apiRejectUserRequestSaga = ({ id }) => {
  axios.delete(`${API_CONFIRMATION_USERS}/${id}`);
};

const apiCheckboxNovonordiskSaga = ({ subscribed }) => {
  axios.put(API_CHECKBOX_NOVONORDISK_USER_SAGA, {
    user: {
      subscription_sponsor: subscribed,
    },
  });
};

const loadUser = (id) => axios.get(`${API_SHOW_USER}${id}`);

// const apiGetSponsorsRepresentative = () =>
//   axios.get(API_SPONSORS_REPRESENTATIVES, {
//     params: { is_representative: true },
//   });

// const apiGetSponsorsRepresentativeRequests = (params) =>
//   axios.get(API_SPONSORS_REPRESENTATIVES_REQUESTS, {
//     params,
//   });

const getCurrentUser = (state) => state.users.user;
const getCurrentSession = (state) => state.session;

const notififyAccountCreate = () => {
  toast.success("You're account was successfully created.");
};

const notififyProfileUpdate = () => {
  toast.success("Your profile was successfully updated.");
};

const notififyValidateError = (errors) => {
  toast.success(errors);
};

const writeAuthSessionToStorage = (user, session) => {
  storage.setSessionData(user, session);
};

function* createUser({ user }) {
  const userData = user;
  try {
    const errors = validator.validate(userData, "user");
    if (errors) {
      yield put(addValidateError(ERROR_TYPE_USER_CREATE_ERROR, errors));
      return;
    } else {
      yield put(cleanErrors(ERROR_TYPE_USER_CREATE_ERROR));
    }

    const response = yield call(apiCreateUser, userData);

    const user = response.data.user;
    const session = {
      token: response.data.token,
    };

    yield call(writeAuthSessionToStorage, user, session);

    yield put(updateUser(user, session));

    yield call(notififyAccountCreate);
  } catch (e) {
    yield put(addErrorsSaga(ERROR_TYPE_USER_CREATE_ERROR, e.response));
  }
}

function* loadCurrentUser() {
  try {
    const currentUser = yield select(getCurrentUser);
    if (!currentUser.id) {
      return;
    }
    const response = yield call(loadUser, currentUser.id);
    const user = response.data.user;
    const session = {
      token: response.data.token,
    };
    yield put(updateUser(user, session));
    yield call(writeAuthSessionToStorage, user, session);
  } catch (e) {
    yield put(addRequestError(e.response));
  }
}

function* updateUrlUser(data) {
  try {
    const userUrl = {
      id: data.data.id,
      is_valid: true,
      email_confirmed: true,
    };
    const sessionUrl = {
      token: data.data.token,
    };
    yield put(updateUser(userUrl, sessionUrl));
    const response = yield call(loadUser, userUrl.id);
    const user = response.data.user;
    const session = {
      token: response.data.token,
    };
    yield put(updateUser(user, session));
    yield call(writeAuthSessionToStorage, user, session);
  } catch (e) {}
}

function* updateUserSaga({ user }) {
  console.log("updateUserSaga");
  const userData = user;
  try {
    const currentUser = yield select((store) => store.users.user);
    const errors = false; //validator.validate(userData, 'userProfile');
    if (errors) {
      yield put(addValidateError(ERROR_TYPE_USER_UPDATE_ERROR, errors));
      return;
    } else {
      yield put(cleanErrors(ERROR_TYPE_USER_UPDATE_ERROR));
    }
    const response = yield call(apiUpdateUser, userData);

    const user = response.data.user;
    const session = {
      token: response.data.token,
    };

    yield put(updateUser(user, session));

    yield call(writeAuthSessionToStorage, user, session);

    yield call(notififyProfileUpdate);

    if (currentUser.is_valid != user.is_valid) {
      yield put(setProfileConfirmation(ZOOM_INFO_STATUS.open));
    }
    yield put(push("/"));
    yield call(() => window.scrollTo(0, 0));
  } catch (e) {
    yield put(addErrorsSaga(ERROR_TYPE_USER_UPDATE_ERROR, e.response));
  }
}

function* updateNovonordiskUserSaga({ subscribed }) {
  // const userData = user;
  try {
    // const currentUser = yield select(store => store.users.user);
    // const errors = false //validator.validate(userData, 'userProfile');
    // if (errors) {
    //   yield put(addValidateError(ERROR_TYPE_USER_UPDATE_ERROR, errors));
    //   return;
    // } else {
    //   yield put(cleanErrors(ERROR_TYPE_USER_UPDATE_ERROR))
    // }
    const response = yield call(apiCheckboxNovonordiskSaga, subscribed);

    // const user = response.data.user;
    // const session = {
    //   token: response.data.token
    // };

    // yield put(updateNovonordiskUser(user));

    // yield call(writeAuthSessionToStorage, user, session);

    // yield call(notififyProfileUpdate);

    // if (currentUser.is_valid != user.is_valid) {
    //   yield put(setProfileConfirmation(ZOOM_INFO_STATUS.open))
    // }
    // yield put(push('/'))
    // yield call(() => window.scrollTo(0, 0))
  } catch (e) {
    yield put(addErrorsSaga(ERROR_TYPE_USER_UPDATE_ERROR, e.response));
  }
}

function* sendApproveUsersSaga({ confirmation_users }) {
  try {
    yield call(apiSendApproveUsersSaga, confirmation_users);
  } catch (e) {}
}

function* sendConfirmationUsersSaga({ confirmation_users }) {
  try {
    yield call(apiSendConfirmationUsersSaga, confirmation_users);
  } catch (e) {}
}

function* approveUserRequestSaga(id) {
  try {
    yield call(apiApproveUserRequestSaga, id);
  } catch (e) {}
}

function* rejectUserRequestSaga(id) {
  try {
    yield call(apiRejectUserRequestSaga, id);
  } catch (e) {}
}

// function* getSponsorsRepresentative() {
//   try {
//     const responce = yield call(apiGetSponsorsRepresentative);
//     yield put(setSponsorsRepresentatives(responce.data));
//   } catch (e) {}
// }

// function* getSponsorsRepresentativeRequests({ payload }) {
//   try {
//     const responce = yield call(apiGetSponsorsRepresentativeRequests, payload);
//     yield put(setSponsorsRepresentativesRequest(responce.data));
//   } catch (e) {}
// }

function* loadNotifications({ payload }) {
  try {
    const responce = yield call(apiGetNotifications, payload);
    yield put(setNotificationsInfinite(responce.data));
  } catch (e) {}
}

function* loadNotificationsCounts() {
  try {
    const { data } = yield call(apiGetNotificationsCount);
    yield put(setNotificationsCount(data.count));
  } catch (e) {}
}

function* markNotifications({ payload }) {
  try {
    const { ids, callback } = payload;
    const { data } = yield call(apiMarkNotifications, ids);
    callback();
    // yield put(setNotificationsCount(data.count));
  } catch (e) {}
}

function* getNotifications({ payload }) {
  try {
    const responce = yield call(apiGetNotifications, payload);
    yield put(setNotification(responce.data));
  } catch (e) {}
}

function* createUserSaga() {
  yield takeLatest(CREATE_USER_SAGA, createUser);
}

function* loadCurrentUserSaga() {
  yield takeLatest(LOAD_CURRENT_USER_SAGA, loadCurrentUser);
}

function* __updateUserSaga() {
  yield takeLatest(UPDATE_USER_SAGA, updateUserSaga);
}

function* __updateNovonordiskUserSaga() {
  yield takeLatest(UPDATE_NOVONORDISK_USER_SAGA, updateNovonordiskUserSaga);
}

function* updateUrlUserSaga() {
  yield takeLatest(UPDATE_URL_USER_SAGA, updateUrlUser);
}
function* __sendApproveUsersSaga() {
  yield takeEvery(SEND_DISCIPLINES_APPROVE_SAGA, sendApproveUsersSaga);
}
function* __sendConfirmationUsersSaga() {
  yield takeEvery(SEND_CONFIRMATION_USERS_SAGA, sendConfirmationUsersSaga);
}

function* __approveUserRequestSaga() {
  yield takeEvery(APPROVE_USER_REQUEST_SAGA, approveUserRequestSaga);
}
function* __rejectUserRequestSaga() {
  yield takeEvery(REJECT_USER_REQUEST_SAGA, rejectUserRequestSaga);
}

function* __approveIpnaRequestSaga() {
  yield takeEvery(APPROVE_IPNA_REQUEST_SAGA, approveUserRequestSaga);
}
function* __rejectIpnaRequestSaga() {
  yield takeEvery(REJECT_IPNA_REQUEST_SAGA, rejectUserRequestSaga);
}

// function* __getSponsorsRepresentative() {
//   yield takeEvery(GET_SPONSORS_REPRESENTATIVE, getSponsorsRepresentative);
// }

// function* __getSponsorsRepresentativeRequests() {
//   yield takeEvery(
//     GET_SPONSORS_REPRESENTATIVE_REQUESTS,
//     getSponsorsRepresentativeRequests
//   );
// }

function* __loadNotifications() {
  yield takeEvery(LOAD_NOTIFICATIONS, loadNotifications);
}

function* __loadNotificationsCounts() {
  yield takeEvery(LOAD_NOTIFICATIONS_COUNT, loadNotificationsCounts);
}
function* __markNotifications() {
  yield takeEvery(MARK_NOTIFICATIONS, markNotifications);
}

function* __getNotifications() {
  yield takeEvery(GET_NOTIFICATIONS, getNotifications);
}
export {
  __approveIpnaRequestSaga,
  __approveUserRequestSaga,
  // __getSponsorsRepresentative,
  // __getSponsorsRepresentativeRequests,
  __rejectIpnaRequestSaga,
  __rejectUserRequestSaga,
  __sendApproveUsersSaga,
  __sendConfirmationUsersSaga,
  __updateNovonordiskUserSaga,
  __updateUserSaga,
  createUserSaga,
  loadCurrentUserSaga,
  updateUrlUserSaga,
  __loadNotifications,
  __getNotifications,
  __loadNotificationsCounts,
  __markNotifications,
};



// WEBPACK FOOTER //
// ./src/sagas/users.js